import React from 'react';
import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import { Row } from 'components/Containers/Row/Row';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import { Button } from 'components/form/Button/Button';
import { Link } from 'components/navigation/Link/Link';
import { ACTIONS } from 'types/mrph.pageName.constants';
import './AutoLoanRateComparisonModuleView.scss';
import classnames from 'classnames';

const RateComparisonTile = props => {
  const oddsClassName = classnames(
    'flex-column items-align-center justify-center scoreTileSection',
    props.backgroundColor,
  );
  const oddsLabelClassName = classnames('caption bold', props.fontOddsLabel);

  return (
    <FlexContainer className={'flex-column rateTileSection'}>
      <FlexContainer className={oddsClassName}>
        <Label className={'H4 mH5'}>{props.score}</Label>
        <Label className={oddsLabelClassName}>{props.odds}</Label>
      </FlexContainer>

      <FlexContainer
        className={'justify-around margT16 m-flex-column m-items-align-center'}
      >
        <FlexContainer className="flex-column items-align-center infoBox">
          <Label className="Body-1 mSubtitle-2 mNotBold">
            {'Interest Rate'}
          </Label>
          <Label className="H5 mSubtitle-1">{props.rate}</Label>
        </FlexContainer>
        <FlexContainer className="flex-column items-align-center m-margT16 infoBox">
          <Label className="Body-1 mSubtitle-2 mNotBold">
            {'Total Payments'}
          </Label>
          <Label className="H5 mSubtitle-1">{props.totalPayments}</Label>
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

const AutoLoanRateComparisonModuleView = props => {
  return (
    <SectionContainer className={'autoLoanRateComparisonContainer m-padB24'}>
      <Row>
        <FlexContainer className={'justify-between padB24'}>
          <Label className={'H4 mH5 m-text-16'}>
            {'Increase your score to get lower interest rates and save'}
          </Label>

          <Link
            to="/goals"
            location={ACTIONS}
            onClickCallback={props.onLinkClick}
            isInline
          >
            <Button
              mrphType="primary"
              className="m-hide seeWhatYouCanDo"
              rounded
            >
              <FlexContainer className="justify-center align-items-center">
                <Label type="Subtitle-2" color="primary_cta_text_light">
                  {'See what you can do'}
                </Label>
              </FlexContainer>
            </Button>
          </Link>
        </FlexContainer>
        <FlexContainer
          className={
            'grayShadow16 border-rad8px padTB24 flex-column padLR24 m-padLR16 rateSection'
          }
        >
          <FlexContainer className={'justify-center'}>
            <Label className={'H5 text-center mBody-1'}>
              {'$30,000 auto loan  /  72 months'}
            </Label>
          </FlexContainer>

          <FlexContainer className={'padT24 justify-between'}>
            <RateComparisonTile
              backgroundColor={'bgYellow025'}
              fontOddsLabel={'fontYellow400'}
              rate={'11.03%'}
              totalPayments={'$41,472'}
              score={'600'}
              odds={'FAIR'}
            />
            <RateComparisonTile
              backgroundColor={'bgLgreen025'}
              fontOddsLabel={'fontLgreen400'}
              rate={'4.55%'}
              totalPayments={'$33,984'}
              score={'710'}
              odds={'GOOD'}
            />
          </FlexContainer>
          <Label className={'caption padT24'}>
            {'Based on Experian’s State of the Automotive Finance Market 2020'}
          </Label>
        </FlexContainer>
        <Link
          to="/goals"
          location={ACTIONS}
          onClickCallback={props.onLinkClick}
          isInline
          ariaLabel="link"
          title="link"
        >
          <Button mrphType="primary" className="d-hide margT24" rounded>
            <FlexContainer className="justify-center align-items-center">
              <Label type="Subtitle-2" color="primary_cta_text_light">
                {'See what you can do'}
              </Label>
            </FlexContainer>
          </Button>
        </Link>
      </Row>
    </SectionContainer>
  );
};

export default AutoLoanRateComparisonModuleView;
